import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { SubventionService } from '../subvention.service';
import { SubventionAmortisationModel, summarizeAmortisation } from './subvention-amortisation.model';
import { Utils } from '../../../../shared/utils';
import { NotificationService } from '../../../../modules_v2/shared/services/notification.service';

export interface SubventionAmortisationDialogData {
    uid: string;
    title?: string;
}

@Component({
    selector: 'convfact-subvention-amortisationtable',
    templateUrl: './subvention-amortisation-table-dialog.component.html',
    styleUrls: ['./subvention-amortisation-table-dialog.component.css'],
    standalone: false
})
export class SubventionAmortisationTableDialogComponent implements OnInit {
    rows: SubventionAmortisationModel[] = [];
    columns = ['year', 'month', 'accountActivity', 'amount'];
    loading = true;
    loadError = false;
    exporting = false;

    name = '';
    total = 0;
    accumulated = 0;
    remaining = 0;

    static open(dialog: MatDialog, data: SubventionAmortisationDialogData): Observable<void> {
        return dialog.open(SubventionAmortisationTableDialogComponent, {
            width: '760px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            autoFocus: false,
            data,
        }).afterClosed();
    }

    constructor(
        public dialogRef: MatDialogRef<SubventionAmortisationTableDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SubventionAmortisationDialogData,
        private subventionService: SubventionService,
        private notify: NotificationService,
    ) { }

    ngOnInit(): void {
        this.subventionService.getAmortisation(this.data.uid)
            .then(response => {
                this.rows = Array.isArray(response) ? response : [];
                Object.assign(this, summarizeAmortisation(this.rows));
                this.loading = false;
            })
            .catch(() => {
                this.loadError = true;
                this.loading = false;
            });
    }

    export(): void {
        if (this.exporting) return;
        this.exporting = true;
        this.dialogRef.disableClose = true;
        this.subventionService.export(this.data.uid)
            .then(blob => {
                FileSaver.saveAs(blob, Utils.GetExcelName('Amortizacion_' + (this.name || this.data.title || 'Subvencion')));
                this.notify.ok('Excel generado correctamente');
            })
            .catch(() => this.notify.error('No se pudo generar el Excel de amortización'))
            .then(() => {
                this.exporting = false;
                this.dialogRef.disableClose = false;
            });
    }

    closeDialog(): void {
        if (this.exporting) return;
        this.dialogRef.close();
    }
}
